import type { StoryTemplateWithUrls } from 'schemas';
import type { EntityCardProps } from '@/components/EntityCard';
import { storyTemplatesPageMessages } from '../storyTemplatesPage.messages';
import { sharedMessages } from '@/shared-messages/shared.messages';

/**
 * Transforms story template data to EntityCard component props
 * @param storyTemplate - Story template from the API
 * @returns Props object for EntityCard component
 */
export const transformStoryTemplateToEntityCard = (
  storyTemplate: StoryTemplateWithUrls
): EntityCardProps => {
  // Prepare details - show age range, themes, and roles
  const details = [
    {
      label: storyTemplatesPageMessages.ageRangeLabel,
      value: storyTemplate.ageRange,
    },
    {
      label: storyTemplatesPageMessages.themesLabel,
      value: storyTemplate.storyThemes
        .map((theme) => sharedMessages.storyThemeOptions[theme])
        .join(', '),
    },
    {
      label: storyTemplatesPageMessages.rolesLabel,
      value: storyTemplate.story_template_roles
        .map((role) => role.title)
        .join(', '),
    },
  ];

  return {
    title: storyTemplate.title,
    description: storyTemplate.description,
    imageUrls: storyTemplate.coverImageUrl
      ? [storyTemplate.coverImageUrl]
      : undefined,
    imageAlt: storyTemplate.title,
    details: details.length > 0 ? details : undefined,
  };
};
